import type { Messages } from "./en";

export const zhHant: Messages = {
  meta: {
    pageTitle: "{{page}} - Calendar App",
    appName: "日曆應用",
  },
  nav: {
    appTitle: "日曆應用",
    home: "首頁",
    records: "記錄",
    dashboard: "儀表板",
    admin: "管理",
    adminWithPage: "管理-{{page}}",
    users: "使用者",
    cron: "排程",
    trash: "垃圾桶",
    settings: "設定",
    logout: "登出",
    language: "語言",
    record: "記錄",
    calendar: "日曆",
    place: "地點",
    resetPassword: "重置密碼",
  },
  common: {
    save: "儲存",
    saveChanges: "儲存變更",
    cancel: "取消",
    close: "關閉",
    confirm: "確認",
    delete: "刪除",
    add: "新增",
    edit: "編輯",
    view: "檢視",
    search: "搜尋",
    map: "地圖",
    submit: "送出",
    reset: "重設",
    run: "執行",
    restore: "還原",
    loading: "載入中…",
    pleaseSelect: "請選擇",
    invalidDate: "日期無效",
    notAvailable: "不適用",
    warning: "警告：",
    showHide: "顯示/隱藏",
    unableToLoadData: "無法載入資料。",
    pleaseEnterValidField: "請輸入有效的{{field}}！",
    pleaseEnterTheField: "請輸入［{{field}}］！",
  },
  fields: {
    password: "密碼",
    confirmPassword: "確認密碼",
    confirmPasswordSentence: "確認密碼",
    currentPassword: "目前密碼",
    newPassword: "新密碼",
    newPasswordSentence: "新密碼",
    email: "電子郵件",
    emailAddress: "電子郵件地址",
    id: "編號",
    username: "使用者名稱",
    role: "角色",
    name: "名稱",
    title: "標題",
    description: "說明",
    address: "地址",
    color: "顏色",
    calendar: "日曆",
    calendars: "日曆",
    place: "地點",
    record: "記錄",
    startDate: "開始日期",
    endDate: "結束日期",
    start: "開始",
    end: "結束",
    prefix: "前綴",
    created: "建立時間",
    lastUpdated: "最後更新",
    defaultShow: "預設顯示",
    calendarName: "日曆名稱",
    placeName: "地點名稱",
    recordType: "記錄類型",
    action: "操作",
    selectCalendars: "選擇日曆",
  },
  login: {
    title: "登入",
    login: "登入",
    passwordEmpty: "請輸入密碼。",
    passwordIncorrect: "密碼錯誤。請再試一次，或按「忘記密碼」重設。",
    emailInvalid: "請輸入有效的電子郵件。",
    forgotPassword: "忘記密碼？",
    forgotPasswordTitle: "忘記密碼",
    submit: "登入",
    resetPassword: "重設密碼",
    resetEmailSent: "重設密碼電郵已成功寄出。",
    resetEmailFailed: "無法寄出重設密碼電郵，請再試一次。",
  },
  reset: {
    title: "重設密碼",
    passwordEmpty: "請輸入密碼。",
    unableToReset: "無法重設密碼！",
    userNotFound: "找不到使用者！",
    linkExpired: "重設連結已過期！請重新申請。",
    passwordsDoNotMatch: "兩次輸入的密碼不一致！",
    invalidResetLink: "重設連結無效！",
    passwordResetSuccessful: "密碼已成功重設！",
    submit: "送出",
    linkExpiredTitle: "連結已過期",
  },
  record: {
    createOneSuccess: "記錄（{{id}}）已成功建立！",
    createManySuccess: "已成功建立 {{num}} 筆記錄！",
    createFailed: "無法建立新記錄！",
    updateFailed: "無法更新記錄（{{id}}）！",
    updateMultiFailed: "無法更新記錄（{{ids}}）！",
    updateSuccess: "記錄（{{id}}）已成功更新！",
    updateMultiSuccess: "記錄（{{ids}}）已成功更新！",
    deleteFailed: "無法刪除記錄（{{id}}）！",
    deleteMultiFailed: "無法刪除記錄（{{ids}}）！",
    deleteSuccess: "記錄（{{id}}）已刪除！",
    deleteMultiSuccess: "記錄（{{ids}}）已刪除！",
    failedToLoad: "無法取得記錄資料！",
    failedToFindId: "找不到記錄編號！",
    idInvalid: "記錄編號無效！",
    editMany: "編輯記錄（{{count}}）",
    deleteMany: "刪除記錄（{{count}}）",
  },
  calendar: {
    createSuccess: "日曆（{{name}}）已成功建立！",
    createFailed: "無法建立新日曆！",
    updateFailed: "無法更新日曆（{{name}}）！",
    updateSuccess: "日曆（{{name}}）已成功更新！",
    deleteFailed: "無法刪除日曆（{{name}}）！",
    deleteSuccess: "日曆（{{name}}）已刪除！",
    failedToLoad: "無法取得日曆資料！",
    nameInvalid: "日曆名稱（{{name}}）無效！",
    nameExists: "日曆名稱（{{name}}）已存在！",
    colorInvalid: "日曆顏色無效！",
    add: "新增日曆",
    edit: "編輯日曆",
    menu: "日曆",
    listTitle: "日曆",
    noCalendars: "尚未有日曆！",
    selectCalendars: "選擇日曆",
    name: "日曆名",
    namePlaceholder: "日曆名稱",
    color: "顏色",
    defaultShow: "預設顯示",
  },
  place: {
    createSuccess: "地點（{{name}}）已成功建立！",
    createFailed: "無法建立新地點！",
    updateFailed: "無法更新地點（{{name}}）！",
    updateSuccess: "地點（{{name}}）已成功更新！",
    deleteFailed: "無法刪除地點（{{name}}）！",
    deleteSuccess: "地點（{{name}}）已刪除！",
    failedToLoad: "無法取得地點資料！",
    nameInvalid: "地點名稱（{{name}}）無效！",
    nameExists: "地點名稱（{{name}}）已存在！",
    addressEmpty: "地點地址為空！",
    add: "新增地點",
    edit: "編輯地點",
    listTitle: "地點",
  },
  cron: {
    createSuccess: "排程工作（{{name}}）已成功建立！",
    createFailed: "無法建立新的排程工作！",
    updateFailed: "無法更新排程工作（{{id}}）！",
    updateSuccess: "排程工作（{{id}}）已成功更新！",
    deleteFailed: "無法刪除排程工作（{{id}}）！",
    deleteSuccess: "排程工作（{{id}}）已刪除！",
    failedToLoad: "無法取得地點資料！",
    invalid: "排程值無效！",
    exists: "排程工作（{{name}}）已存在！",
    runSuccess: "排程工作（{{name}}）已成功執行！",
    runFailed: "排程工作（{{name}}）執行失敗！",
    addCronJob: "新增排程工作",
    editCronJob: "編輯排程工作",
  },
  calendarUi: {
    failedToFindEvent: "找不到活動（{{id}}）！",
    failedToGetApi: "找不到［calendarApi］！",
  },
  event: {
    add: "新增活動",
    edit: "編輯活動",
    deleteTitle: "刪除活動",
    deleteConfirm: "確定要刪除這個活動嗎？",
    unableToGet: "無法取得活動資料！",
    copied: "活動（{{id}}）已複製！",
    copy: "複製活動",
    endBeforeStart: "結束日期必須晚於開始日期！",
    endDateInvalid: "請輸入有效的結束日期！",
    endDateRequired: "請輸入結束日期！",
    mapTitle: "地圖 - {{name}}",
  },
  grid: {
    emptySelection: "請選擇一筆記錄！",
    emptyData: "找不到記錄！",
    doesNotIncludeRecord: "表格不包含記錄（{{id}}）！",
    doesNotIncludeMultiRecord: "表格不包含記錄（{{ids}}）！",
    failedToFindRowById: "找不到編號為（{{id}}）的記錄！",
    pleaseSelectRecords: "請至少選擇 1 筆記錄！",
    failedToRestore: "還原（{{type}}）記錄失敗！",
    failedToDelete: "刪除（{{type}}）記錄失敗！",
    restored: "已還原 {{count}} 筆（{{type}}）記錄！",
    deleted: "已刪除 {{count}} 筆（{{type}}）記錄！",
    copiedToClipboard: "已複製到剪貼簿！",
    paginationNext: "下一頁",
    paginationPrevious: "上一頁",
  },
  settings: {
    title: "設定",
    password: "密碼",
    passwordEmpty: "請輸入密碼。",
    passwordIncorrect: "舊密碼不正確！",
    confirmPasswordNotMatch: "密碼不一致！",
    updateSuccess: "密碼已更新！",
    userDetailNotFound: "找不到使用者資料！",
    keepCurrentPassword: "留空則保留目前密碼",
  },
  user: {
    failedToLoad: "無法取得使用者資料！",
    usernameEmpty: "請輸入使用者名稱。",
    passwordEmpty: "請輸入密碼。",
    passwordMismatch: "密碼不一致。",
    createSuccess: "使用者已建立。",
    createFailed: "無法建立使用者。",
    updateSuccess: "使用者已更新。",
    updateFailed: "無法更新使用者。",
    deleteSuccess: "使用者已刪除。",
    deleteFailed: "無法刪除使用者。",
    cannotDeleteSelf: "無法刪除目前登入的使用者。",
    selectOne: "請選擇一位使用者。",
    addUser: "新增使用者",
    editUser: "編輯使用者",
    deleteTitle: "刪除使用者",
    deleteWarning:
      "此操作會永久刪除該使用者。若使用者仍有地點或記錄，則無法刪除。",
  },
  dashboard: {
    title: "儀表板",
    fetchFailed: "無法取得儀表板資料。",
    nextEvents: "即將到來的活動",
    prevEvents: "先前的活動",
    upcomingEvents: "即將到來的活動",
    nextHoliday: "下一個假期",
    noHoliday: "沒有假期…",
    monthEvents: "本月活動數",
    monthlySummary: "{{year}} 每月摘要",
    eventDistribution: "{{year}} 活動分佈",
    totalEventDistribution: "活動總分佈",
    events: "活動",
  },
};
